export enum AmplitudeFeatureFlag {
  INSURANCE = 'fluid-7389-coi-warning',
  FAILED_TRANSACTIONS = 'failed-transactions',
  GEOFENCE_CREATE = 'geofence_create',
}
